import React from 'react'
import { Form } from 'react-bootstrap'


const SwitchComponent = ({
	callbackParent,
	control,
	checked=false,
	disabled=false,
	errors,
	inline=false,
	label=null,
	name,
	register,
	required=true,
	title,
	value,
	...rest
}) => {

	return (
		<>

			<Form.Group className='mb-3'>
				{label && 
					<Form.Label
						className='mb-0'
						htmlFor={name}
					>{label}</Form.Label>
				}

				<Form.Check
					defaultChecked={checked}
					defaultValue={value}
					block={disabled}
					id={(disabled == true) ? `disabled-${name}` : name}
					label={title}
					name={name}
					onChange={(e) => { callbackParent(e.target.checked) }}
					type='switch'
					{...register(name, {
						required: {
							value: required,
							message: 'Campo obrigatório'
						}
					})}
					{...rest}
				/>
				
				{errors[name] && <p className='mt-1 form-error'>{errors[name].message}</p>}
			</Form.Group>

		</>
	)

}

export default SwitchComponent;